<template>
  <b-card class="bg-white rounded-xl p-4 px-2 py-2">
    <div class="flex items-center pb-4">
      <base-button
        icon
        type=""
        class="bg-f4f5f6 custpad5-10"
        @click="handleClick('admin-sessiondates')"
      >
        <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>
        <span class="btn-inner--text">Back</span>
      </base-button>
    </div>

    <h2 class="text-2xl font-semibold">Session Date:</h2>
    <div class="flex">
      <div class="my-4 w-full flex">
        <div class="my-4 w-1/2 pr-2">
          <b-form-group label="Date:">
            <date-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              required
              :config="{ allowInput: true }"
              placeholder="Select Date"
              v-model="date"
              class="cust-wfull"
              valueType="format"
            >
            </date-picker>
          </b-form-group>
          <span v-if="dayError" class="text-danger fsize12">{{
            msg.date
          }}</span>
        </div>
        <div class="my-4 w-1/2 pl-2">
          <b-form-group label="Start Time:">
            <date-picker
              v-model="starttime"
              format="HH:mm"
              value-type="format"
              type="time"
              class="cust-wfull"
              :config="configdateTimePicker"
              placeholder="HH:mm"
            >
            </date-picker>
          </b-form-group>
        </div>
        <div class="my-4 w-1/2 pl-2">
          <b-form-group label="End Time:">
            <date-picker
              v-model="endtime"
              format="HH:mm"
              value-type="format"
              type="time"
              class="cust-wfull"
              :config="configdateTimePicker"
              placeholder="HH:mm"
            >
            </date-picker>
            <span v-if="timeError" class="text-danger fsize12">{{
              msg.time
            }}</span>
          </b-form-group>
        </div>
      </div>

      <!-- <button >Submit</button> -->
    </div>
    <!-- <h2 class="text-2xl font-semibold">Application Closes By:</h2>
    <div class="flex">
      <div class="my-4 w-full flex">
        <div class="my-4 w-1/3 pr-2">
          <b-form-group label="Date:">
            <date-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              required
              :config="{ allowInput: true }"
              placeholder="Select Date"
              v-model="date"
              class="cust-wfull"
              valueType="format"
            >
            </date-picker>
          </b-form-group>
        </div>
      </div>

      
    </div> -->
    <div class="text-center py-4">
      <button
        class="bg-primary px-10 py-2 rounded text-white text-l"
        @click="handlesubmit"
      >
        Save
      </button>
    </div>
  </b-card>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { ChevronLeftIcon } from "vue-feather-icons";
import { mapState } from "vuex";
export default {
  components: {
    ChevronLeftIcon,
    DatePicker,
  },
  data() {
    return {
      timeError: false,
      dayError: false,
      msg: {},
      blog_data: {},
      date: "",
      starttime: "",
      endtime: "",
      day: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },
    };
  },
  methods: {
    async reset() {
      this.date = "";
      this.starttime = "";
      this.endtime = "";
      this.day = "";
    },
    async handlesubmit() {
      this.timeError = false;
      this.dayError = false;

      this.day = new Date();
      let payload = {
        date: this.date,
        day: this.date,
        starttime: this.starttime,
        endtime: this.endtime,
      };
      let today = new Date();
      today =
        today.getFullYear() +
        "-" +
        ((today.getMonth() + 1).length != 2
          ? "0" + (today.getMonth() + 1)
          : today.getMonth() + 1) +
        "-" +
        today.getDate();
      try {
        this.dayError = false;
        this.timeError = false;

        if (!this.date) {
          this.dayError = true;
          this.timeError = false;

          this.msg.date = "Date should be added";
        } else if (this.date < today) {
          this.dayError = true;
          this.timeError = false;

          this.msg.date = "Enter valid date";
        } else if (this.starttime > this.endtime) {
          this.timeError = true;
          this.dayError = false;

          this.msg.time = "Start Time and End Time should be valid";
        } else if (this.starttime === this.endtime) {
          this.timeError = true;
          this.dayError = false;

          this.msg.time = "Start Time and End Time should be different";
        } else {
          this.timeError = false;
          this.dayError = false;
          // return;
          let data = await this.$store.dispatch("coach/Sessiondate", payload);
          let loader = this.$loading();
          this.$router.push({ name: "admin-sessiondates" });
          if (data.code == 200) {
            this.$swal.fire({
              text: "Changes saved successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            this.reset();
          }
          loader.close();
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
